(function(){
  var hoverBox = document.querySelector('.copyright-hover');
  var creditsTrigger = document.querySelector('.credits-dianacorp');

  creditsTrigger.addEventListener('click', function(e){
      e.preventDefault();

      if(hoverBox.classList.contains('opened')) {
          hoverBox.classList.remove('opened');
      } else {
          hoverBox.classList.add('opened');
      }
  });


  (hoverBox).addEventListener('mouseleave', function() {
    hoverBox.classList.remove('opened');
  });
})();
